import { Author, Section, Tag } from "@src/app/types/Cue";

export function getArticleAuthorNames(authors: Author[]) {
  const authorList = [] as string[];

  authors.map((author: Author) => {
    authorList.push(author.name);
  });
  return authorList.join(", ");
}

export function getArticleChapter1(section: Section) {
  let chapter1 = "";

  if (section.parent.uniqueName !== "ece_frontpage") {
    chapter1 = section.name;
  }

  return chapter1.replaceAll("-", " ");
}

export function getArticleLevel2(section: Section) {
  let level2 = section.name;

  if (section.parent.uniqueName !== "ece_frontpage") {
    level2 = section.parent.name;
  }

  return level2.replaceAll("-", " ");
}

export function getArticleKeywords(keywords: Tag[]) {
  const keywordsList = [] as string[];

  keywords.map((keyword: Tag) => {
    keywordsList.push(keyword.name.toLowerCase());
  });

  return keywordsList.join(",");
}
